import * as React from 'react';

import {AlertBox} from 'shells/alert-box/alert-box';
import {Card} from 'shells/card/card';
// @ts-expect-error - imported from .js/.jsx file
import {BroadcastIcon} from 'shells/icon/svg/broadcast-icon';
import {HalfAndHalfIcon} from 'shells/icon/svg/half-and-half-icon';
// @ts-expect-error - imported from .js/.jsx file
import {NewsletterIcon} from 'shells/icon/svg/newsletter-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {RadioGroup} from 'shells/radio/radio-group';
import {Body} from 'shells/typography/body';
import {Header} from 'shells/typography/header';

import {AbTestingFeatureGate} from '../../limits/feature-gates/ab-testing-feature-gate-modal';

import {EditionCreationFooter} from './edition-creation-footer';
import {EditionTypeRadio} from './edition-type-radio';
import {A_B_TEST_EDITION, STANDARD_EDITION} from './new-edition-modal';
import type {EditionType} from './new-edition-modal';

type Props = {
    setShowTypeModal: (arg1: boolean) => void;
    setShowComparisonFieldsSelectModal: (arg1: boolean) => void;
    selectedType: EditionType;
    setSelectedType: (arg1: EditionType) => void;
    type: 'broadcasts' | 'newsletterEditions' | 'dripSequenceEditions' | 'campaignTemplates';
    userFacingNoun: string;
    handleEditionCreation: () => void;
    isCreating: boolean;
    errorMessage: string | null | undefined;
};

export function EditionTypeSelection(props: Props) {
    const {setShowTypeModal, setShowComparisonFieldsSelectModal, selectedType, setSelectedType} =
        props;

    const [showFeatureGate, setShowFeatureGate] = React.useState(false);

    const Icon = props.type === 'broadcasts' ? BroadcastIcon : NewsletterIcon;

    const onCreate = () => {
        if (selectedType === A_B_TEST_EDITION) {
            setShowComparisonFieldsSelectModal(true);
        } else {
            props.handleEditionCreation();
        }
    };

    return (
        <>
            {showFeatureGate ? (
                <AbTestingFeatureGate isOpen={showFeatureGate} setIsOpen={setShowFeatureGate} />
            ) : (
                <AlertBox onClose={() => setShowTypeModal(false)}>
                    <Card
                        hasBorder={true}
                        hasShadow={false}
                        backgroundColor='white'
                        borderColor='white'
                    >
                        <div className='pad-16'>
                            <StackLegacy spacing={16}>
                                <Header>Choose a type of {props.userFacingNoun}</Header>
                                <div className='mb-16'>
                                    <RadioGroup
                                        name='edition-type'
                                        selectedValue={selectedType}
                                        // @ts-expect-error
                                        onChange={setSelectedType}
                                    >
                                        <div className='mb-16'>
                                            <EditionTypeRadio
                                                value={STANDARD_EDITION}
                                                label='Standard'
                                                sublabel='Send to all subscribers at the same time'
                                                Icon={Icon}
                                            />
                                        </div>
                                        <EditionTypeRadio
                                            value={A_B_TEST_EDITION}
                                            label='A/B test'
                                            sublabel='Test two versions and automatically send to the winner'
                                            Icon={HalfAndHalfIcon}
                                            disabled={!NutClientConfig.hasAbTesting}
                                            setShowFeatureGate={setShowFeatureGate}
                                        />
                                    </RadioGroup>
                                </div>
                                {props.errorMessage && (
                                    <Body color='error'>{props.errorMessage}</Body>
                                )}
                                <EditionCreationFooter
                                    onCancel={() => setShowTypeModal(false)}
                                    onCreate={onCreate}
                                    errorMessage={props.errorMessage}
                                    isCreating={props.isCreating}
                                    userFacingNoun={props.userFacingNoun}
                                />
                            </StackLegacy>
                        </div>
                    </Card>
                </AlertBox>
            )}
        </>
    );
}
